// Modules
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

// Constants
import PATHS from "~constants/paths"

// Context
import { useAuthContext } from "~context/authContext"

const useResetPasswordPath = () => {
  const navigate = useNavigate()

  // Get from context
  const { loggedUser, isResettingPassword } = useAuthContext()
  const resettingPassword = isResettingPassword()

  // Use Effect
  useEffect(() => {
    if (!resettingPassword) {
      navigate(PATHS.login)
    }
  }, [loggedUser]) // eslint-disable-line react-hooks/exhaustive-deps

  return resettingPassword
}

export default useResetPasswordPath
